import { Container } from '@mui/material';
import Page from '../../../components/Page';
import CompanyAdvertiseForm from './CompanyAdvertiseForm';

const index = () => {
  return (
    <Page title={'Company Advertise'}>
      <Container maxWidth={'xl'}>
        <CompanyAdvertiseForm />
      </Container>
    </Page>
  );
};

export default index;

